import * as Sentry from "@sentry/react";
import { v4 as uuidv4 } from 'uuid'
import React, { useEffect, useRef } from 'react'
import { IStringInputSettings, LabelVariants } from '../../inputs.interface'

import { IInputStatus } from '../../../../interface/progress.interface'

const useString = (
  inputRef: React.RefObject<HTMLInputElement>,
  settings: IStringInputSettings,
  status: IInputStatus,
  styles: any,
  dependenciesValue: string | null = null
) => {
  const { labelVariant, hasBadge } = settings
  const id = uuidv4()

  const contentRef = useRef<HTMLDivElement>(null)
  const labelRef = useRef<HTMLLabelElement>(null)
  // const [localStatus, setLocalStatus] = useState<IInputStatus>(
  //   IInputStatus.none
  // )

  // useEffect(() => {
  //   handleChange(value)
  // }, [value])

  // useEffect(() => {
  //   // Запустить handler при изменении value
  //   const time = setTimeout(() => {
  //     handleChange(name, value)
  //   }, 1000)
  // }, [value])

  // useEffect(() => {
  //   console.log(status)
  //   setLocalStatus(status)
  // }, [status])

  useEffect(() => {
    try {
      // Устанавить стили в зависимости от статуса
      switch (status) {
        case IInputStatus.error:
          contentRef.current?.classList.add(styles.errorContent)
          inputRef.current?.classList.add(styles.badgeError)
          contentRef.current?.classList.remove(styles.successContent)
          inputRef.current?.classList.remove(styles.badgeSuccess)
          inputRef.current?.classList.remove(styles.badgeProfit)
          break
        case IInputStatus.apiError:
          contentRef.current?.classList.add(styles.errorContent)
          inputRef.current?.classList.add(styles.badgeError)
          contentRef.current?.classList.remove(styles.successContent)
          inputRef.current?.classList.remove(styles.badgeSuccess)
          inputRef.current?.classList.remove(styles.badgeProfit)
          break
        case IInputStatus.success:
          contentRef.current?.classList.add(styles.successContent)
          inputRef.current?.classList.add(styles.badgeSuccess)
          contentRef.current?.classList.remove(styles.errorContent)
          contentRef.current?.classList.remove(styles.error)
          inputRef.current?.classList.remove(styles.badgeError)
          inputRef.current?.classList.remove(styles.badgeProfit)
          break
        default:
          hasBadge && inputRef.current?.classList.add(styles.badgeProfit)
          contentRef.current?.classList.remove(styles.successContent)
          contentRef.current?.classList.remove(styles.errorContent)
          inputRef.current?.classList.remove(styles.badgeError)
          inputRef.current?.classList.remove(styles.badgeSuccess)
      }
    } catch (error) {
      console.log(error)
    }
  }, [status])

  useEffect(() => {
    try {
      // Добавить стили для label в зависимости от варианта
      switch (labelVariant) {
        case LabelVariants.outside:
          labelRef.current?.classList.add(styles.labelOutside)
          break
        default:
          labelRef.current?.classList.remove(styles.labelOutside)
      }
    } catch (error) {
      console.log(error)
    }
  }, [labelVariant])

  return {
    id,
    inputRef,
    contentRef,
    labelRef,
  }
}

export default useString
